import { render, staticRenderFns } from "./LsMenu.vue?vue&type=template&id=626bfda0&"
import script from "./LsMenu.vue?vue&type=script&lang=js&"
export * from "./LsMenu.vue?vue&type=script&lang=js&"
import style0 from "./LsMenu.vue?vue&type=style&index=0&id=626bfda0&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports